import { render, staticRenderFns } from "./PreviewTapHint.vue?vue&type=template&id=e3671f9c&scoped=true"
import script from "./PreviewTapHint.vue?vue&type=script&lang=ts"
export * from "./PreviewTapHint.vue?vue&type=script&lang=ts"
import style0 from "./PreviewTapHint.vue?vue&type=style&index=0&id=e3671f9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3671f9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
